import { AbstractProduct } from '@/src/lib/product/types';
import { Links } from '@/src/types/generic';

export interface CategoryNode {
  [key: string]: string | null | number | Array<CategoryNode> | undefined | boolean | Links;
  id?: string | null;
  nodeId: number;
  name: string;
  metaTitle?: string | null;
  metaKeywords?: string | null;
  metaDescription?: string | null;
  isActive: boolean;
  order: number | null;
  url: string;
  children: Array<CategoryNode>;
  parents?: Array<CategoryNode>;
}

export interface CategoryTreeFilter {
  nodeId: number;
  name: string;
  docCount: number;
  children: Array<CategoryTreeFilter>;
}

export interface FacetConfig {
  parameterName: string;
  isMultiValued: boolean;
}

export interface ValueFacet {
  name: string;
  localizedName: string;
  docCount: number | null;
  values: Array<{
    value: string | number;
    doc_count: number;
  }>;
  activeValue: string | null | Array<string>;
  config: FacetConfig;
  isDisabled?: boolean;
}

export interface RangeFacet {
  name: string;
  localizedName: string;
  min: number;
  max: number;
  activeMin: number;
  activeMax: number;
  docCount: number | null;
  config: FacetConfig;
  isDisabled?: boolean;
}

export interface FilterChip {
  label: string;
  params: Array<{
    name: string;
    value: string;
  }>;
}

export enum CatalogRequestParams {
  SORT = 'sort',
  IPP = 'ipp',
  IS_AVAILABLE = 'is_available',
  PAGE = 'page',
  CURRENCY = 'currency',
}

export type CatalogSearchSuggestionCategory = {
  name: string;
  url: string;
};

export type CatalogSearchSuggestionCmsPage = {
  name: string;
  url: string;
};

export type CatalogSearchSuggestionAbstractProduct = Omit<AbstractProduct, 'abstractDescription' | 'prices'> & {
  url: string;
};

export type CatalogSearchSuggestionAttributes = {
  completion: Array<string>;
  categories: Array<CatalogSearchSuggestionCategory>;
  cmsPages: Array<CatalogSearchSuggestionCmsPage>;
  categoryCollection: Array<CatalogSearchSuggestionCategory>;
  cmsPageCollection: Array<CatalogSearchSuggestionCmsPage>;
  abstractProducts: Array<CatalogSearchSuggestionAbstractProduct>;
};

export enum FacetType {
  VALUES = 'values',
  RANGE = 'range',
}

export type DeserializedCategoryNode = CategoryNode & {
  type: string;
  links: Links;
};
